<main class="main">
  <page-header *ngIf="!isAuthPage"></page-header>
  <div class="content">
    <app-address-verification-banner *ngIf="!isAuthPage"></app-address-verification-banner>
    <router-outlet></router-outlet>
  </div>
</main>
